import { render } from "./RankingFirst.vue?vue&type=template&id=61aa2885&scoped=true&ts=true&lang=pug"
import script from "./RankingFirst.vue?vue&type=script&lang=ts"
export * from "./RankingFirst.vue?vue&type=script&lang=ts"

import "./RankingFirst.vue?vue&type=style&index=0&id=61aa2885&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aa2885"]])

export default __exports__